module.exports = __webpack_public_path__ + "static/media/blog-last-episodes.84c0401d.png";